import { Spacing } from "@material-ui/core/styles/spacing";
import createBreakpoints, { Breakpoints } from "./createBreakpoints";
import createPalette, { Palette } from "./createPalette";
import createTypography, { Typography } from "./createTypography";
import { ElectricSettings } from "Types/api/ElectricSettings";

const breakpoints = createBreakpoints();

export interface Theme {
    breakpoints: Breakpoints;
    palette: Palette;
    spacing: Spacing;
    typography: Typography;
}

export interface WithTheme {
    theme: Theme;
}

declare module "styled-components" {
    // tslint:disable-next-line:no-empty-interface
    export interface DefaultTheme extends Theme {}
}

export default function createStyledComponentsTheme(
    settings?: ElectricSettings,
    loadedFont: string = "sans-serif"
): Theme {
    const palette = createPalette(settings);
    const typography = createTypography({
        fontFamily: `${loadedFont}, sans-serif`,
    });

    return {
        breakpoints,
        palette,
        spacing: {
            unit: 8,
        },
        typography,
    };
}
